var postal = require("./PubSub");

/**
 * Interface to be implemented by all views in the app.
 * Contains basic functionality for the views to be managed by the core app framework.
 * @interface
 */
var AbstractView = {
    /**
     * @abstract
     * @returns {DefaultHeader~Configuration} The header configuration for this view
     */
    getHeaderConfiguration : function() {
        throw "Not implemented: getHeaderConfiguration";
    },

    /**
     * @abstract
     * @returns {jQuery} The jQuery element containing the content of this view
     */
    getContent : function() {
        throw "Not implemented: getContent";
    },

    /**
     * @returns {string} The key of the appropriate content view container for this view
     */
    getDisplayMode : function() {
        return "menu";
    },

    /**
     * Makes the view content visible in the DOM
     */
    show : function() {
        this.getContent().show();
    },

    /**
     * Hides the view content in the DOM
     */
    hide : function() {
        this.getContent().hide();
    },

    /**
     * Resizes the view content as necessary to the width/height specified by the caller
     * @param {number} width - the width to be occupied by the view content
     * @param {number} height - the height to be occupied by the view content
     */
    resize : function(width, height) {
        // Do nothing -- to be overridden as necessary in subclasses
    },

    /**
     * Get the name for this view, used in navigation history
     * @returns {string} The name of the view
        */
    getHashName : function() {
        return "";
    },

    /**
     * Propagate a custom event back from the view to interested controllers
     * @param channel - name of the channel
     * @param topic - name of the topic
     * @param data - dict of arguments needed by the event
        */
    publishEvent : function(channel, topic, data) {
        var bus = postal.channel(channel);
        bus.publish(topic, data || {});
    },

    publishRequest : function(channel, topic, data) {
        var bus = postal.channel(channel);

        return bus.request({
            topic : topic,
            data : data || {},
            timeout : 2000
        });
    },

    /**
     * @returns {boolean} Whether this view requires the user to be authenticated
     */
    requiresAuthentication : function() {
        return true;
    },

    /**
     * @returns {boolean} Whether this view is a leaf, used in navigation history
     */
    isLeafView : function() {
        return false;
    },

    /**
     * @returns {[string]} Array of hash names that are known children of this view. used in navigation history.
     */
    getChildrenHashNames : function() {
        return this.childrenHashNames;
    },

    /**
     * Add a child view to this view (Recording its hash name)
     * @param view - the child view to append.
     */
    addChildView : function(view) {
        if (this.childrenHashNames) {
            this.childrenHashNames.push(view.getHashName());
        } else {
            this.childrenHashNames = [view.getHashName()];
        }
    },

    /**
     * Remove all child views from this view
     */
    removeChildViews : function() {
        this.childrenHashNames = undefined;
    }
};

module.exports = AbstractView;